'use strict';

angular.module('shiftTraderApp')
  .service('StatisticsService', ['$http', 'ServerUrls', 'Session', function ($http, ServerUrls, Session) {

    var getUserStatistic = function(userId, statName, options) {
      return $http.get(ServerUrls.current.nodeApi + 'stats/user/' + userId, {
        params: _.extend(options, {stat: statName})
      });
    };

    var getOrgStatistic = function(orgId, statName, options) {
      return $http.get(ServerUrls.current.nodeApi + 'stats/organization/' + orgId, {
        params: _.extend(options, {stat: statName})
      });
    };

    return {
      getUserStatistic: getUserStatistic,
      getOrgStatistic: getOrgStatistic
    };

  }]);
